import { z } from "zod";
const catalogReviewReplySchema = z
    .object({
    body: z.string(),
    replied_at: z.string(),
})
    .strip();
export const catalogReviewItemSchema = z
    .object({
    id: z.number(),
    rating: z.number(),
    comment: z.string().nullable(),
    submitted_at: z.string(),
    provider_reply: catalogReviewReplySchema.nullable(),
})
    .strip();
export const catalogReviewsPaginationSchema = z
    .object({
    page: z.number(),
    limit: z.number(),
    total_items: z.number(),
    total_pages: z.number(),
})
    .strip();
/**
 * Wire shape of GET /api/v2/catalog/services/:id/reviews: items are the
 * top-level `data` array, pagination is nested under `meta.pagination`.
 */
export const catalogReviewsApiResponseSchema = z
    .object({
    data: z.array(catalogReviewItemSchema),
    meta: z
        .object({
        pagination: catalogReviewsPaginationSchema,
    })
        .strip(),
})
    .strip();
